import React from 'react';
import { Field } from 'redux-form';
import { AsyncSelectField, renderCurrency, renderField, renderFieldCheckCompact } from '../../../../../Utils/renderField/renderField';

const RecetaRow = ({ system, index, fields, getTypeOfTransport }) => {
    return (
        <tr>
            <td className="titulo-left-padded" style={{ minWidth: '230px' }}>
                <Field
                    name={`${system}.name`}
                    type="text"
                    component={renderField}
                    className="form-control name-input"
                    placeholder="Rubro"
                />
            </td>
            <td className="titulo-left-padded" style={{ minWidth: '270px' }}>
                <Field
                    name={`${system}.type_of_transport`}
                    component={AsyncSelectField}
                    loadOptions={getTypeOfTransport}
                    valueKey="id"
                    labelKey="name"
                    className="form-control"
                    isMulti
                />
            </td>
            <td className="titulo-left-padded">
                <Field
                    name={`${system}.cost`}
                    type="number"
                    component={renderCurrency}
                    placeholder={'Q 0.0000'}
                    decimalScale={4}
                />
            </td>
            <td className="titulo-left-padded">
                <Field
                    name={`${system}.is_iva_credit`}
                    component={renderFieldCheckCompact}
                    className='form-control'
                />
            </td>
            <td className="titulo-left-padded">
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div>
                        <img
                            src={require('assets/img/icons/Accion-Eliminar.svg')}
                            alt="Borrar"
                            title="Borrar"
                            className="action_img"
                            onClick={() => fields.remove(index)}
                        />
                    </div>
                </div>
            </td>
        </tr>
    );
};

export default RecetaRow;
